import React from 'react';
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import NoDataFound from '../../NoDataFound/NoDataFound';
import ChartFormatIndianNumber from "../../../Common/ChartFormatIndianNumber";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const EliteWarehouseChart = ({ chartData }) => {
  if (!Array.isArray(chartData) || chartData.length === 0) {
    return <NoDataFound height={300} />;
  }

  const labels = chartData.map(item =>
    item.warehouse.charAt(0).toUpperCase() + item.warehouse.slice(1)
  );
  const dataValues = chartData.map(item => item.quantity);

  const data = {
    labels,
    datasets: [
      {
        label: 'Quantity',
        data: dataValues,
        backgroundColor: (ctx) => {
          const chart = ctx.chart;
          const { ctx: canvasCtx, chartArea } = chart;
          if (!chartArea) return;
          const gradient = canvasCtx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
          gradient.addColorStop(0, '#00c6ff');
          gradient.addColorStop(1, '#0072ff');
          return gradient;
        },
        borderRadius: 20,
        barThickness: 15
      }
    ]
  };

  const options = {
    responsive: true,
    interaction: {
      mode: 'index',
      intersect: false
    },
    maintainAspectRatio: false, // allow chart to fit the fixed height container
    plugins: {
      tooltip: {
        mode: 'index',
      intersect: false,
        callbacks: {
          label: ctx => `Quantity: ${ChartFormatIndianNumber(ctx.raw)}`
        }
      },
      legend: {
        display: false
      },
      datalabels: {
        display: false   //  This disables all inline datalabels
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: (value) => ChartFormatIndianNumber(value)
        },
        title: {
          display: false
        }
      }
    }
  };

  return (
    <div style={{ height: 360 }}>
      <Bar data={data} options={options} />
    </div>
  );
};

export default EliteWarehouseChart;
